const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-flag-line',
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      title: 'Notre Mission',
      description: 'Notre objectif fondamental est d\'assurer la livraison de prestations de construction supérieures et de solutions d\'entretien efficaces. Notre engagement est de fournir des infrastructures durables et des réponses sur mesure qui optimisent la valeur ajoutée pour nos clients et contribuent à leur développement.'
    },
    {
      icon: 'ri-eye-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Notre Vision',
      description: 'Aspirer à la position de référence mondiale dans les domaines de la construction et de la maintenance, en déployant des approches novatrices, pérennes et performantes pour satisfaire pleinement les exigences de notre clientèle.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Mission & Vision</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Nos valeurs fondamentales qui guident chacune de nos actions et décisions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className={`w-16 h-16 ${value.iconBg} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${value.icon} text-3xl ${value.iconColor}`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed text-lg">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
